import {AuthHttp} from 'angular2-jwt';
import { Injectable } from '@angular/core';
import { UtilsService } from './utils.service';
import { ProjectService } from './project.service';
import { TopicService } from './topic.service';
import { TagService } from './tag.service';
import { SearchTermService } from './search-term.service';
import { CriterionService } from './criterion.service'
import { Observable }  from 'rxjs/Observable';
import './rxjs-operators';

@Injectable()
export class ArcService {
  serviceUrl: string;
  userNs: string;
  app = 'searchman'
  utils: UtilsService
  projects: ProjectService
  tags: TagService
  topics: TopicService
  sts: SearchTermService
  cs: CriterionService

  constructor(
    private http: AuthHttp
  ) {
    console.log("ARC SERVICE")
    this.serviceUrl = `${location.protocol}//gae-test.ecomole.com/a2`
  }

  communicate(type: string, payload: Object): Observable<any> {
    if (!this.userNs)
      this.userNs = JSON.parse(localStorage.getItem('auth_profile'))['user_id']
    return this.http.post(this.serviceUrl,
      JSON.stringify({
        payload: payload,
        type: type,
        app: this.app,
        u: this.userNs,
        email: this.utils.email
      })).map((res) => {
        // console.log("Communicate response:", res)
        return payload['isDownload'] ? res.text() : res.json()
      },
      (err) => console.log("COMMUNICATE ERROR", err)
      )
  }

  run(payload: Object): Observable<any> {
    // if (payload['fun'] !== 'downloadExportFile')
    // console.log('RUN', payload)
    return this.communicate('run', payload)
  }

}



// WEBPACK FOOTER //
// ./src/app/arc.service.ts